module.exports = __webpack_public_path__ + "assets/img/thumb-HR-Connect-Website.4ef6ac1e.jpg";